var PageTransitions = (function () {

    var self = {};

    self.init = function () {

        //  PJAX
        require ('./../../../../build/node_modules/@components/jquery-pjax/jquery.pjax.js');

        //  Documentation: https://github.com/defunkt/jquery-pjax
        App.Globals.$document
            .pjax('a:not([target="_blank"]):not([href^="#"])', '#main-wrap')
            .on('pjax:send site:filter:start', function () {
                App.Globals.$body.addClass('page-transition');
            })
            .on('pjax:success site:filter:end', function () {
                App.Globals.$body.removeClass('page-transition');
            });

    };

    return self;

}());

module.exports = PageTransitions;
